import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToMany } from "typeorm";
import { TrimItemsMapping } from "./trims-item-configuration.entity";
@Entity('trims_mapping')
export class TrimsMapping {

  @PrimaryGeneratedColumn("increment", { name: 'trim_id' })
  trimId: number;

  @Column("int", {
    nullable: false,
    name: "brand_id"
  })
  brandId: number;
  @Column("int", {
    nullable: false,
    name: "pack_style_id"
  })
  packStyleId: number;
  @Column("int", {
    nullable: false,
    name: "variant_id"
  })
  variantId: number;
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column("int", {
    nullable: false,
    name: "end_customer_id"
  })
  endCustomerId: number;

  @OneToMany(type => TrimItemsMapping, trimItems => trimItems.trimInfo, { cascade: true, onUpdate: 'CASCADE' })
  trimItemsInfo: TrimItemsMapping[];
}
